import type { Timestamp } from '@bufbuild/protobuf/wkt'

import type { Email, EmailThread } from '@/gen/cortado/v1/emails_pb'

/**
 * Return the aggregate message boundary only after its message snapshot is
 * present in the UI. This timestamp is deliberately sourced from the thread,
 * because it is the exact field the server uses to calculate unread state.
 */
export function getRenderedThreadReadThrough(
  loadedThread: EmailThread | undefined,
  messages: readonly Email[],
): Timestamp | undefined {
  if (messages.length === 0) return undefined
  return loadedThread?.lastMessageAt
}
